import { ErrorRounded } from '@mui/icons-material';
import { Stack, styled, Typography } from '@mui/material';

export const StyledContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const StyledErrorMessage = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.error.main,
}));

export const StyledErrorRounded = styled(ErrorRounded)(({ theme }) => ({
  color: theme.palette.error.main,
}));
